import styled from 'styled-components';
import { theme } from './theme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

export const ModalContainer = styled.div`
  background-color: ${theme.colors.backgroundLight};
  padding: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.large};
  width: 90%;
  max-width: 400px;
  box-shadow: ${theme.shadows.large};
  border: 1px solid ${theme.colors.border};
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.h2`
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.lg};
  font-family: ${theme.fonts.main};
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

export const AuthInput = styled.input`
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.border};
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  outline: none;
  font-size: 1rem;

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const AuthButton = styled.button`
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.gradients.primary};
  color: ${theme.colors.text};
  border: none;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin-top: ${theme.spacing.sm};
  width: 100%;
  transition: opacity ${theme.transitions.fast};

  &:hover {
    opacity: 0.9;
  }
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.accent};
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${theme.spacing.md};
  font-size: 0.9rem;
  align-self: center;

  &:hover {
    color: ${theme.colors.primary};
  }
`;

export const TabRow = styled.div`
  display: flex;
  background-color: ${theme.colors.background};
  border-radius: ${theme.borderRadius.medium};
  padding: 4px;
  margin-bottom: ${theme.spacing.lg};
  gap: 4px;
`;

export const Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border: none;
  border-radius: ${theme.borderRadius.small};
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all ${theme.transitions.fast};
  background: ${p => (p.$active ? theme.gradients.primary : 'transparent')};
  color: ${p => (p.$active ? theme.colors.text : theme.colors.textSecondary)};

  &:hover {
    color: ${theme.colors.text};
  }
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  margin: ${theme.spacing.md} 0;
  color: ${theme.colors.textSecondary};
  font-size: 0.8rem;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${theme.colors.border};
  }

  span {
    padding: 0 ${theme.spacing.sm};
  }
`;
